import AccessServiceIcon from './AccessServiceIcon';

export default AccessServiceIcon;
